export function getRouteFromRide(ride) {
  if (!ride) {
    return 'Unknown route';
  }

  if (ride.originStation && ride.originStation.city && ride.destinationStation && ride.destinationStation.city) {
    return `${ride.originStation.city.cityName} to ${ride.destinationStation.city.cityName}`;
  } else if (ride.pickUp && ride.dropOff) {
    return `${ride.pickUp.name || ride.pickUp.address} to ${ride.dropOff.name || ride.dropOff.address}`;
  }

  return 'Unknown route';
}

export function getProductFromRide(ride) {
  if (!ride) {
    return '';
  }

  if (ride.isStandby && ride.product === 'Shared') {
    return 'Confirmed Standby';
  }

  return ride.product;
}
